import React, { ReactNode, useLayoutEffect, useState } from 'react';
import { BrowserHistory } from 'history';
import { Router } from 'react-router-dom';

export interface CustomRouterProps {
  basename?: string;
  children: ReactNode;
  history: BrowserHistory;
}

const CustomRouter = (props: CustomRouterProps) => {
  const { basename, children, history } = props;
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigator={history}
      navigationType={state.action}>
      {children}
    </Router>
  );
};

export default CustomRouter;
